// Vendor imports
const Immutable = require('immutable')
const PropTypes = require('prop-types')
// Common Client V2 imports
const CollectionModelRecord = require('client-v2/common/models/collection/record')
const UserModelRecord = require('client-v2/common/models/user/record')
const {
  defaultReviver,
  keyedReviver,
  listReviver
} = require('client-v2/common/state/record-reviver')

class ArticleProfileCollectionsRecord extends Immutable.Record({
  // getUrlMixHistoryV1 fields
  isCurator: Boolean(), // Implied when smashing together fetched results
  items: null,
  template: null,
  // getUrlMixHistoryV2 fields
  collections: null,
  user: null
}) {
  // No methods
}

ArticleProfileCollectionsRecord.propTypes = {
  // getUrlMixHistoryV1 fields
  isCurator: PropTypes.bool,
  items: PropTypes.arrayOf(PropTypes.object),
  template: PropTypes.string,
  // getUrlMixHistoryV2 fields
  collections: PropTypes.arrayOf(PropTypes.shape(CollectionModelRecord.propTypes)),
  user: PropTypes.shape(UserModelRecord.propTypes)
}

ArticleProfileCollectionsRecord.reviver = keyedReviver(ArticleProfileCollectionsRecord, {
  // getUrlMixHistoryV1 fields
  items: listReviver(defaultReviver),
  // getUrlMixHistoryV2 fields
  collections: listReviver(CollectionModelRecord.reviver),
  user: UserModelRecord.reviver
})

module.exports = ArticleProfileCollectionsRecord
